(function () {
    document.querySelectorAll('[data-color-picker]').forEach(root => {
        const input = root.querySelector('input[type="hidden"][name]');

        function select(btn) {
            root.querySelectorAll('.swatch').forEach(b => b.classList.toggle('is-selected', b === btn));
            const v = btn.getAttribute('data-color') || getComputedStyle(btn).getPropertyValue('--c').trim();
            if (input) input.value = v;
            root.dispatchEvent(new CustomEvent('change', {detail: {color: v}}));
        }

        root.querySelectorAll('.swatch').forEach(btn => {
            btn.addEventListener('click', () => select(btn));
        });
        // init first
        const first = root.querySelector('.swatch.is-selected') || root.querySelector('.swatch');
        if (first) select(first);
    });
})();
